import { render, staticRenderFns } from "./w-button.vue?vue&type=template&id=47f05bf0&scoped=true"
import script from "./w-button.vue?vue&type=script&lang=ts"
export * from "./w-button.vue?vue&type=script&lang=ts"
import style0 from "./w-button.vue?vue&type=style&index=0&id=47f05bf0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f05bf0",
  null
  
)

export default component.exports